/**
 * Inaction engine copy / user-facing strings
 *
 * All user-facing text is centralized here to ensure:
 * - English-only consistency
 * - Easy localization in the future
 * - No mixed language in UI
 */

export const INACTION_COPY = {
  // Duration formatting
  duration: {
    fewMinutes: 'a few minutes',
    formatMinutes: (minutes: number) => `${minutes}m`,
    formatHours: (hours: number) => `${hours}h`,
    formatHoursMinutes: (hours: number, minutes: number) => `${hours}h ${minutes}m`,
  },

  // Why now messages by state
  whyNow: {
    fresh: {
      neverContacted: (dueInLabel: string | null, slaHours: number) =>
        `New lead. First touch due in ${dueInLabel || `${slaHours}h`}.`,
      contacted: 'Recent activity. Stay ahead of the first-touch window.',
    },
    due: {
      neverContacted: 'First touch due soon. Contact before it cools.',
      contacted: 'Next touch due soon. Keep the lead from cooling.',
    },
    overdue: {
      neverContacted: (overdueByLabel: string | null) =>
        `First touch overdue by ${overdueByLabel || 'several hours'}. Cooling accelerating.`,
      contacted: (overdueByLabel: string | null) =>
        `Follow-up overdue by ${overdueByLabel || 'several hours'}. Risk is increasing.`,
    },
    stale: {
      neverContacted: 'Stale lead. Attempt a reactivation or close-loop.',
      contacted: 'Stale relationship. Attempt a reactivation or close-loop.',
    },
  },

  // Fallback when timing data is missing
  fallback: {
    noTimingData: 'Timing unavailable — treat as a new lead and secure a first touch.',
  },

  // UI labels
  labels: {
    dueIn: (label: string) => `Due in ${label}`,
    overdueBy: (label: string) => `Overdue by ${label}`,
  },

  // Keep Warm queue
  keepWarm: {
    stateDueNow: 'Due now',
    stateCooling: 'Cooling',
    dueIn: (label: string) => `Due in ${label}`,
    overdueBy: (label: string) => `Overdue by ${label}`,
    waitingForReply: 'Waiting for reply',
  },
} as const;
